module.exports = __webpack_public_path__ + "static/img/icon_locate@2x.e2a79c8a.png";